import React from 'react';
import ReferralsTable from './Components/ReferralsTable';

const ReferralsPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <ReferralsTable />
      </div>
    </div>
  );
};

export default ReferralsPage;
